import React from 'react';
import { motion } from 'framer-motion';
const pillars = [{
  emoji: '🎨',
  title: 'Signature Visuelle',
  transformation: 'Te voir autrement dans le miroir'
}, {
  emoji: '🏠',
  title: 'Sanctuaire Intérieur',
  transformation: 'Transformer la solitude en force'
}, {
  emoji: '🤝',
  title: 'Connexion Sociale',
  transformation: "Choisir ton cercle. Occuper l'espace."
}];
export function MethodSection() {
  return <section className="bg-white py-10 px-6 md:py-16" data-id="element-156">
      <div className="max-w-4xl mx-auto" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-158">
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal text-center mb-3" data-id="element-159">
            La Méthode des 3 Piliers
          </h2>

          <p className="text-center text-lg text-gray-600 mb-8" data-id="element-160">
            30 jours. 15 minutes par jour. Zéro bla-bla.
          </p>

          <div className="space-y-4 mb-8" data-id="element-161">
            {pillars.map((pillar, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-5 bg-cream p-5 rounded-lg border border-gray-200" data-id="element-162">
                <div className="text-4xl flex-shrink-0" data-id="element-163">{pillar.emoji}</div>
                <div data-id="element-164">
                  <h3 className="font-playfair text-xl text-burgundy font-semibold" data-id="element-165">
                    {pillar.title}
                  </h3>
                  <p className="text-charcoal" data-id="element-166">{pillar.transformation}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="space-y-3 text-lg" data-id="element-167">
            <p data-id="element-168">
              <span className="text-green-600 font-bold mr-2" data-id="element-169">✓</span>
              Actions de 5 à 15 minutes — conçues pour les mamans débordées
            </p>
            <p data-id="element-170">
              <span className="text-green-600 font-bold mr-2" data-id="element-171">✓</span>
              Un jour. Une action. Un résultat.
            </p>
            <p data-id="element-172">
              <span className="text-green-600 font-bold mr-2" data-id="element-173">✓</span>
              Calendrier jour par jour inclus — dès le Jour 1 ce soir
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}